module.exports = __webpack_public_path__ + "static/img/ywqk_cd_pic.93fbc0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ywqk_cd_pic.png
// module id = u0Jt
// module chunks = 200